import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "space-y-2" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", { class: "section__title" }, "Badges with different shapes:", -1)
const _hoisted_3 = { class: "w-full gap-4 grid--auto-cols" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" some text ")
const _hoisted_5 = { class: "space-y-2" }
const _hoisted_6 = /*#__PURE__*/_createVNode("h1", { class: "section__title" }, "Small with badges with texts:", -1)
const _hoisted_7 = { class: "w-full gap-4 grid--auto-cols" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" +9 ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" +99 ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 5 ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" +100 ")
const _hoisted_12 = { class: "space-y-2" }
const _hoisted_13 = /*#__PURE__*/_createVNode("h1", { class: "section__title" }, "Badges on avatars:", -1)
const _hoisted_14 = { class: "flex flex-wrap items-center w-full space-x-8" }
const _hoisted_15 = { class: "p-2" }
const _hoisted_16 = { class: "p-2" }
const _hoisted_17 = { class: "p-2" }
const _hoisted_18 = { class: "p-2" }
const _hoisted_19 = { class: "p-2" }
const _hoisted_20 = { class: "p-2" }
const _hoisted_21 = { class: "space-y-2" }
const _hoisted_22 = /*#__PURE__*/_createVNode("h1", { class: "section__title" }, "Badges on Icons:", -1)
const _hoisted_23 = { class: "w-full gap-8 grid--auto-cols grid--auto-cols-xs" }
const _hoisted_24 = /*#__PURE__*/_createVNode("span", { class: "text-sm" }, " +9", -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("span", { class: "text-sm" }, " 4", -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("span", { class: "text-xs" }, " New", -1)
const _hoisted_27 = { class: "space-y-2" }
const _hoisted_28 = /*#__PURE__*/_createVNode("h1", { class: "section__title" }, "Badges on buttons:", -1)
const _hoisted_29 = { class: "flex flex-row items-center w-full space-x-24" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Count ")
const _hoisted_31 = { class: "p-8" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_w_badge = _resolveComponent("w-badge")
  const _component_w_avatar = _resolveComponent("w-avatar")
  const _component_IconNotification = _resolveComponent("IconNotification")
  const _component_w_icon_with_badge = _resolveComponent("w-icon-with-badge")
  const _component_IconHome = _resolveComponent("IconHome")
  const _component_IconFavorite = _resolveComponent("IconFavorite")
  const _component_IconChat = _resolveComponent("IconChat")
  const _component_IconShoppingCart = _resolveComponent("IconShoppingCart")
  const _component_IconModel = _resolveComponent("IconModel")
  const _component_w_btn = _resolveComponent("w-btn")
  const _component_component_reflecter = _resolveComponent("component-reflecter")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode("div", _hoisted_3, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.shapes, (shape) => {
          return (_openBlock(), _createBlock(_component_w_badge, {
            key: shape,
            shape: shape,
            textColor: "text-white",
            bgColor: "bg-navy-blue-500"
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 2
          }, 1032, ["shape"]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ]),
    _createVNode("div", _hoisted_5, [
      _hoisted_6,
      _createVNode("div", _hoisted_7, [
        _createVNode(_component_w_badge, {
          bgColor: "bg-red-200",
          textColor: "text-red-700"
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }),
        _createVNode(_component_w_badge, {
          bgColor: "bg-red-500",
          textColor: "text-red-200"
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }),
        _createVNode(_component_w_badge, {
          bgColor: "bg-green-500",
          shape: "rounded-full",
          textColor: "text-green-100"
        }, {
          default: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1
        }),
        _createVNode(_component_w_badge, {
          bgColor: "bg-blue-500",
          shape: "rounded-full",
          textColor: "text-blue-100"
        }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode("div", _hoisted_12, [
      _hoisted_13,
      _createVNode("div", _hoisted_14, [
        _createVNode("div", _hoisted_15, [
          _createVNode(_component_w_avatar, {
            src: "https://i.pravatar.cc/200?img=56",
            variant: "rounded-full",
            class: "row-start-1 bg-navy-blue-200 text-navy-blue-650"
          }, {
            badge: _withCtx(() => [
              _createVNode(_component_w_badge, {
                shape: "rounded-full",
                size: "md"
              })
            ]),
            _: 1
          })
        ]),
        _createVNode("div", _hoisted_16, [
          _createVNode(_component_w_avatar, {
            src: "https://i.pravatar.cc/200?img=58",
            variant: "rounded-full",
            size: "xs",
            class: "row-start-1 bg-navy-blue-200 text-navy-blue-650"
          }, {
            badge: _withCtx(({ avatar }) => [
              _createVNode(_component_w_badge, {
                shape: "rounded-full",
                size: "xs",
                avatar: avatar
              }, null, 8, ["avatar"])
            ]),
            _: 1
          })
        ]),
        _createVNode("div", _hoisted_17, [
          _createVNode(_component_w_avatar, {
            src: "https://i.pravatar.cc/200?img=64",
            variant: "rounded-full",
            size: "sm",
            class: "row-start-1 bg-navy-blue-200 text-navy-blue-650"
          }, {
            badge: _withCtx(({ avatar }) => [
              _createVNode(_component_w_badge, {
                shape: "rounded-full",
                bgColor: "bg-red-500",
                size: "sm",
                avatar: avatar
              }, null, 8, ["avatar"])
            ]),
            _: 1
          })
        ]),
        _createVNode("div", _hoisted_18, [
          _createVNode(_component_w_avatar, {
            src: "https://i.pravatar.cc/200?img=65",
            variant: "rounded",
            size: "sm",
            class: "row-start-1 bg-navy-blue-200 text-navy-blue-650"
          }, {
            badge: _withCtx(({ avatar }) => [
              _createVNode(_component_w_badge, {
                shape: "rounded-full",
                bgColor: "bg-green-500",
                size: "sm",
                avatar: avatar
              }, null, 8, ["avatar"])
            ]),
            _: 1
          })
        ]),
        _createVNode("div", _hoisted_19, [
          _createVNode(_component_w_avatar, {
            src: "https://i.pravatar.cc/200?img=67",
            size: "sm",
            class: "row-start-1 bg-navy-blue-200 text-navy-blue-600"
          }, {
            badge: _withCtx(({ avatar }) => [
              _createVNode(_component_w_badge, {
                shape: "rounded-full",
                ping: "",
                position: "top-right",
                bgColor: "bg-blue-500",
                size: "sm",
                avatar: avatar
              }, null, 8, ["avatar"])
            ]),
            _: 1
          })
        ]),
        _createVNode("div", _hoisted_20, [
          _createVNode(_component_w_avatar, {
            src: "https://i.pravatar.cc/200?img=42",
            variant: "rounded-none",
            size: "sm",
            class: "row-start-1 bg-navy-blue-200 text-navy-blue-650"
          }, {
            badge: _withCtx(({ avatar }) => [
              _createVNode(_component_w_badge, {
                shape: "rounded-full",
                bgColor: "bg-green-500",
                size: "sm",
                avatar: avatar
              }, null, 8, ["avatar"])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode("div", _hoisted_21, [
      _hoisted_22,
      _createVNode("div", _hoisted_23, [
        _createVNode(_component_w_icon_with_badge, null, {
          icon: _withCtx(() => [
            _createVNode(_component_IconNotification, {
              height: "32",
              width: "32",
              class: "text-gray-600"
            })
          ]),
          badge: _withCtx(() => [
            _createVNode(_component_w_badge, {
              shape: "rounded-full",
              position: "initial",
              bgColor: "bg-navy-blue-500",
              size: "sm"
            })
          ]),
          _: 1
        }),
        _createVNode(_component_w_icon_with_badge, null, {
          icon: _withCtx(() => [
            _createVNode(_component_IconHome, {
              height: "32",
              width: "32",
              class: "text-gray-600"
            })
          ]),
          badge: _withCtx(() => [
            _createVNode(_component_w_badge, {
              shape: "rounded-full",
              position: "initial",
              bgColor: "bg-red-500",
              size: "sm"
            })
          ]),
          _: 1
        }),
        _createVNode(_component_w_icon_with_badge, null, {
          icon: _withCtx(() => [
            _createVNode(_component_IconFavorite, {
              height: "32",
              width: "32",
              class: "text-gray-600"
            })
          ]),
          badge: _withCtx(() => [
            _createVNode(_component_w_badge, {
              shape: "rounded-full",
              ping: "",
              position: "initial",
              bgColor: "bg-green-500",
              size: "sm"
            })
          ]),
          _: 1
        }),
        _createVNode(_component_w_icon_with_badge, null, {
          icon: _withCtx(() => [
            _createVNode(_component_IconChat, {
              height: "32",
              width: "32",
              class: "text-gray-600"
            })
          ]),
          "badge-text": _withCtx(() => [
            _createVNode(_component_w_badge, {
              bgColor: "bg-red-500",
              shape: "rounded-full",
              textColor: "text-red-100"
            }, {
              default: _withCtx(() => [
                _hoisted_24
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_w_icon_with_badge, null, {
          icon: _withCtx(() => [
            _createVNode(_component_IconShoppingCart, {
              height: "32",
              width: "32",
              class: "text-gray-600"
            })
          ]),
          "badge-text": _withCtx(() => [
            _createVNode(_component_w_badge, {
              bgColor: "bg-blue-500",
              shape: "rounded-full",
              textColor: "text-blue-100"
            }, {
              default: _withCtx(() => [
                _hoisted_25
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_w_icon_with_badge, null, {
          icon: _withCtx(() => [
            _createVNode(_component_IconModel, {
              height: "32",
              width: "32",
              class: "text-gray-600"
            })
          ]),
          "badge-text": _withCtx(() => [
            _createVNode(_component_w_badge, {
              bgColor: "bg-emerald-500",
              shape: "rounded-full",
              size: "xs",
              textColor: "text-emerald-100"
            }, {
              default: _withCtx(() => [
                _hoisted_26
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode("div", _hoisted_27, [
      _hoisted_28,
      _createVNode("div", _hoisted_29, [
        _createVNode(_component_w_btn, {
          onClick: _cache[1] || (_cache[1] = $event => (_ctx.count++))
        }, {
          append: _withCtx(() => [
            _createVNode(_component_w_badge, {
              bgColor: "bg-green-500",
              shape: "rounded-full",
              size: "xs",
              textColor: "text-green-100"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.count), 1 /* TEXT */)
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _hoisted_30
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode("div", _hoisted_31, [
      _createVNode(_component_component_reflecter, { component: _ctx.badge }, null, 8, ["component"])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}